import { CreateAccess } from './create/Index'
import { useEffect, useContext, useState } from "react";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { rqx } from "../../../../../core/request/API";
import { env } from "../../../../../core/Env";
import { Box, Modal, Slide } from "@mui/material";
import { Details } from './details/Index';
import { ShareConfirmation } from '../../../global/DesktopDsg';
import { RemoveAccess } from './removeAccess/Index';
import { NotifCount } from '../../../../../core/request/Notif';
import { FeatureIdState } from '../../../../toolUsage/global/GlobalFcn';
import { CreateFeatureLogs } from '../../../../global/API';

export const ShareAccess = () => {
    const { cloud_state, tool_state } = useContext(ToolContext)
    const { __SESSION } = tool_state
    const { show, withAccess, allUsrList, ulistAccess, openShare, shareType, userList ,searchInput, filterActive, selectedDept, confirmShare, saveLoader, message, successOpen } = cloud_state
    let company_id = __SESSION.data.uaccess[0].company_id;
    const [usrData, setUsrData] = useState(allUsrList.data)

    const handleClose = () => {
        userList.set([])
        searchInput.set('')
        openShare.set(false)
        withAccess.set({val: [], loader: false})
        ulistAccess.set([])
        openShare.set(false)
        filterActive.set({id: 0, name: 'All'})
    }

    const handlerCloseConfirmation = () => {
        confirmShare.set({...confirmShare.data, val : false, type: ''})
    }

    const handlerShareSubmit = async() => {
        if (!saveLoader.data) {
            saveLoader.set(true)
            let mergeArr;
            let data = userList.data.filter(v => { return v.stat.view } )
            if (ulistAccess.data.length > 0) {
                mergeArr = [...ulistAccess.data, ...data]
            }
            let body = {
                company_id: company_id,
                access: (ulistAccess.data.length > 0 ? mergeArr : data).map(v => { return { user_id:v.id, view:v.stat.view, update:v.stat.update, download:v.stat.download } }),
                user_id: atob(__SESSION.data.ainfo.aid).split('_', 2)[1],
                contracts_id: show.data.data.feature_type === 2 ? show.data.data.id : '',
                registration_id: show.data.data.feature_type === 1 ?  show.data.data.id : '',
                folder_id: show.data.data.feature_type === 3 ? show.data.data.folder_id : '',
                documents_id: show.data.data.feature_type === 4 ? show.data.data.id : '',
            }
            const res = await rqx.post(`<<tool>>/${env()}/general-maintenance/cloud/access/create`, body)
            if (res.message === 'success') {
                const fileType = show.data.data.feature_type === 1 ? 'reg' : show.data.data.feature_type === 2 ? 'con' : show.data.data.feature_type === 3 ? 'folder' : 'file'
                let fltr = userList.data.map(v => { return {...v.stat, remove:false, user_id:v.id, file:fileType, file_id:show.data.data.id } } )
                // let fltr = userList.data.map(v => { return {...v.stat, remove:false, user_id:v.id, file:show.data.data.feature_type === 1 ? 'reg' : 'con', file_id:show.data.data.id } } )
                await NotifCount(fltr, __SESSION, 'crtacc')
                await handleClose()
                confirmShare.set({...confirmShare.data, val : false, type: ''})
                saveLoader.set(false)
                openShare.set(false)    
                successOpen.set(true)
                message.set('Successfully shared')
            }
        }
    }

    const initGetWithAccess = async() => {
        withAccess.set({...withAccess.data, val: [], loader: true})
        let params = {
            registration_id: show.data.data.feature_type === 1 ? show.data.data.id : '',
            contracts_id: show.data.data.feature_type === 2 ? show.data.data.id : '',
            folder_id: show.data.data.feature_type === 3 ? show.data.data.id : '',
            documents_id: show.data.data.feature_type === 4 ? show.data.data.id : '',
        }
        let res = await rqx.get(`<<tool>>/${env()}/general-maintenance/cloud/access/read`, params )
        let fdata = res.length === 0 ? res : JSON.parse(res[0].access)
        await getUserWithAccess(res, fdata)
    }

    const getUserWithAccess = (val, fdata) => {
        if (val.length > 0) {
            let fltrAccess = allUsrList.data.users.filter(f => JSON.parse(val[0].access).find(x => f.id  === x.user_id))
            fdata = fltrAccess.map((v) => {
                const d = JSON.parse(val[0].access).filter((c) => c.user_id === v.id)[0];
                return {...v, stat: {...v.stat, view:d.view === undefined ? true : d.view, update : d.update, download: d.download, remove:false}}
            })
            fdata.sort((a, b) => a.first_name.localeCompare(b.first_name))
        }
       
        ulistAccess.set(fdata)
        withAccess.set({...withAccess.data, val: [{...val[0], access:fdata}], loader: false})
    }
    
    useEffect(() => {
        let subscribe = true
        if (subscribe) {
            if (openShare.data) {
                if (show.data.data.access === null || show.data.data.access === undefined) {
                    shareType.set('create_access')
                }
                selectedDept.set([])
            }
            initGetWithAccess()
        }
        return () => subscribe = false
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        const tool_id =  process.env.REACT_APP_TID;
        const SendFeatureLogs = async() => {
            let body = {     
                aid: __SESSION.data.ainfo.aid, 
                path: `${FeatureIdState('bcloud')}->5`,     
                feature_id: 5, 
                feature_name: "shared-documents", 
                tid: tool_id, 
                company_id: __SESSION.data.uaccess[0].company_id, 
                action: 2 // action: 1 = Create, 2 = Read, 3 = Update, 4 = Download, 5 = Export, 
            } 
            
            await CreateFeatureLogs(body) 
        }
        SendFeatureLogs()
        // eslint-disable-next-line
    }, [])
    
    return (
        <Modal open={openShare.data} className="noutlined">
            <Slide in={openShare.data} direction="up" className="noutlined">
                <Box height="100%" width="100%" bgcolor="#ffffff" display="flex" flexDirection="column">
                    {
                        shareType.data === 'create_access' ?
                            <CreateAccess usrData={usrData} setUsrData={setUsrData} />
                        :
                            shareType.data === 'details' ?
                                <Details handleClose={handleClose} />
                            :
                                <RemoveAccess />
                    }
                     <ShareConfirmation 
                         name={
                            show.data.data.feature_type === 1 ? 
                                show.data.data.registration_name 
                            : show.data.data.feature_type === 2 ? 
                                show.data.data.contract_name 
                            : show.data.data.feature_type === 3 ? 
                                show.data.data.folder_name
                            : 
                                show.data.data.file_name
                        } 
                        subname={
                            show.data.data.feature_type === 1 ? 
                                show.data.data.registered_name 
                            : show.data.data.feature_type === 2 ? 
                                show.data.data.client_name
                            : ''
                        }
                        // name={ window.location.pathname === '/my-cloud/shared/list' && sharedFltr.data.type === 'all' ? show.data.data.type_name : show.data.data.feature_type === 1 ? show.data.data.registration_name : show.data.data.contract_name} 
                        // subname={ window.location.pathname === '/my-cloud/shared/list' && sharedFltr.data.type === 'all' ? show.data.data.name : show.data.data.feature_type === 1 ? show.data.data.registered_name : show.data.data.client_name}
                        confirmShare={confirmShare}  
                        cancel={() => handlerCloseConfirmation()}
                        submit={() => handlerShareSubmit()}
                        saveLoader={saveLoader.data}
                    />
                </Box>
            </Slide>
        </Modal>
    )
}
